// 接口域名管理
export default {
    baseURL: "http://192.168.123.111:8800/", // 本地
    resURL: "https://res.yuntsg.com/", // 资源
    // resourceURL: "https://res.yuntsg.com/", // 资源
    resourceURL: "/", // 资源
    pubMedURL: "https://pm.yuntsg.com/", // pubMed
    pubMed4URL: "https://pm4.yuntsg.com/", // pubMed4
    userURL: "https://user.tsgyun.com/", // user
    fullText: "https://fulltext.yuntsg.com/", // user
    searchURL: "https://allsearch.yuntsg.com/", // 统一检索平台
    xueshuURL: "https://xueshu.yuntsg.com/", // 基金
    scholarURL: "https://scholar.yuntsg.com/", // 泉方学术
};

